// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetProfessionByIdRequestModel from '../../model/get-profession-by-id-request-model';
import GetProfessionByIdRequestDTO from '../dto/get-profession-by-id-request-dto';
import dtoSchema from '../schemas/get-profession-by-id-request-schema';

export default abstract class GetProfessionByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetProfessionByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetProfessionByIdRequestDTO>): GetProfessionByIdRequestModel;
  static toModel(dto: DeepPartial<GetProfessionByIdRequestDTO> | undefined | null): GetProfessionByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetProfessionByIdRequestDTO> | undefined | null): GetProfessionByIdRequestModel | undefined {
    return dto ? new GetProfessionByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetProfessionByIdRequestModel> | GetProfessionByIdRequestModel): GetProfessionByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetProfessionByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetProfessionByIdRequestModel, can not map to GetProfessionByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
